/* eslint-disable @typescript-eslint/no-unused-vars */
import {
  RankedTester,
  rankWith,
  RendererProps,
  uiTypeIs,
} from "@jsonforms/core";
import { withJsonFormsLayoutProps } from "@jsonforms/react";
import React from "react";
import { useSelector } from "react-redux";
import { get } from "lodash";
import {
  evaluateContextRule,
  extractPath,
  resolveContextValue,
} from "../utils/commonUtils";

/**
 * Default tester for a FormattedNumber.
 * @type {RankedTester}
 */
export const FormattedNumberRendererTester: RankedTester = rankWith(
  2,
  uiTypeIs("FormattedNumber")
);

/**
 * Default renderer for a Rich text.
 */
function FormattedNumberRenderer({ uischema, visible }: RendererProps) {
  let resolvedContent = uischema.options?.content;
  const reduxStateObj = useSelector((state: any) => state?.reduxState);
  const contextContent = resolveContextValue(reduxStateObj, resolvedContent);
  if (typeof contextContent !== "undefined") {
    resolvedContent = contextContent;
  }

  const style = uischema.options?.style;
  const locales = uischema.options?.locales;
  const notation = uischema.options?.notation;
  const maximumFractionDigits = uischema.options?.maximumFractionDigits;

  const formattedNumber = Intl.NumberFormat(locales || "en-US", {
    notation: notation || "compact",
    maximumFractionDigits: maximumFractionDigits || 1,
  }).format(resolvedContent);

  // Determine if the component should be visible
  let componentVisibility = visible;

  // If there is a context rule, evaluate it and use that visibility rule instead.
  if (uischema.options?.contextRule) {
    // grab the scope from the contextRule
    const scope = extractPath(uischema.options?.contextRule?.condition?.scope);
    // get the redux store state based on the scope provided
    const reduxState = useSelector((state: any) =>
      get(state?.reduxState, scope)
    );
    componentVisibility = evaluateContextRule(
      uischema.options?.contextRule,
      reduxState
    )?.visible;
  }

  return (
    <div
      style={{ ...style }}
      hidden={!componentVisibility}
      data-testid="formatted-number"
    >
      {formattedNumber !== "NaN" ? formattedNumber : resolvedContent}
    </div>
  );
}

export default withJsonFormsLayoutProps(FormattedNumberRenderer);
